<section id="settings-container">
  <app-header title="User Settings"></app-header>
  <div class="container">
    <section>
        <form class="info-box user-settings-form" [formGroup]="settingsForm">
        <!-- https://angular.io/docs/ts/latest/guide/template-syntax.html#!#binding-syntax -->
        <h1 class="info-box-heading">{{ (authenticationService?.identityClaims?.uiowahawkid ?? '') }} ({{ userFullName() }})</h1>
<!--        <h1 class="info-box-heading">{{ user && user.FullName }}</h1>-->
        <div class="info-box-wrapper">
          <div class="info-box-body">
            <div class="section-container flex-column">
              <h2>Roles</h2>
              <p>{{ authenticationService.roles.join(', ') }}</p>
            </div>
            <fieldset>
              <div class="section-container">
                <mat-form-field appearance="outline" class="email-input">
                  <mat-label>Email</mat-label>
                  <input
                    matInput
                    type="text"
                    placeholder="Email"
                    formControlName="Email"

                  />
                </mat-form-field>
              </div>
              <fieldset class="email-notifications">
                <legend>Email Notifications</legend>
                  <div class="notifications-toggle">
                    <span aria-live="polite">
                      @if( !(settingsForm.get('EmailNotifications').value ?? false) ) {
                        Off
                      }
                    </span>
                    <mat-slide-toggle
                      aria-label="Turn Email Notifications On or Off"
                      formControlName="EmailNotifications"
                    >

                    </mat-slide-toggle>
                    <span aria-live="polite">
                      @if( (settingsForm.get('EmailNotifications').value ?? false) ) {
                        On
                      }
                    </span>
                  </div>
<!--                <div class="section-container">-->
<!--                  <mat-radio-group-->
<!--                    class="flex-column"-->
<!--                    formControlName="EmailNotifications"-->
<!--                    aria-label="Turn Email Notifications On or Off"-->
<!--                  >-->
<!--                    <mat-radio-button value="1">-->
<!--                      Email notifications ON-->
<!--                    </mat-radio-button>-->
<!--                    <mat-radio-button value="0">-->
<!--                      Email notifications OFF-->
<!--                    </mat-radio-button>-->
<!--                  </mat-radio-group>-->
<!--                </div>-->
              </fieldset>
            </fieldset>
          </div>
          <div class="info-box-btn flex-row-end user-settings-actions">
            <button
              class="btn-save"
              mat-raised-button
              (click)="save()"
              [disabled]="!settingsForm.valid">
              Save
            </button>
            <button
              mat-raised-button
              type="button"
              [routerLink]="['/', 'correspondences']">
              Cancel
            </button>
          </div>
        </div>
      </form>
    </section>
  </div>
</section>
